import * as React from "react";
import { SVGProps } from "react";

const StatusOkSVG: React.FC<SVGProps<SVGSVGElement>> = (props: SVGProps<SVGSVGElement>) => (
  <svg data-testid="status-ok-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10 0a10 10 0 1 0 10 10A10.01 10.01 0 0 0 10 0Z" fill="#00824B" />
    <path
      d="M10 0a10 10 0 1 0 10 10A10.01 10.01 0 0 0 10 0Z"
      style={{
        stroke: "none",
      }}
    />
    <path
      style={{
        color: "#000",
        fill: "#fff",
        strokeLinecap: "round",
      }}
      d="M15.07 5.75a1.25 1.25 0 0 0-.883.367l-6.68 6.678-2.841-2.541a1 1 0 0 0-.72-.252 1 1 0 0 0-.692.33 1 1 0 0 0 .08 1.412l3.65 3.268a1 1 0 0 0 .653.252 1.25 1.25 0 0 0 1.248-.309l7.07-7.07a1.25 1.25 0 0 0 0-1.768 1.25 1.25 0 0 0-.885-.367z"
    />
  </svg>
);

export default StatusOkSVG;
